import { UPDATE_PREVIEW_SCALE } from "../actions/types";

const initialState = {
  previewWidth: 800,
  previewScale: 1,
};

const applicationReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_PREVIEW_SCALE:
      return {
        ...state,
        previewScale: action.payload.previewScale,
      };
    default:
      return state;
  }
};

export default applicationReducer;
